<template>
    <table class="min-w-full text-left divide-y divide-gray-200 dark:divide-gray-600">
        <thead class="bg-gray-50 dark:bg-gray-700">
            <tr>
                <th class="w-1/3">
                    {{ $t('labels.dataChange') }}
                </th>
                <th class="w-1/3">
                    {{ $t('labels.oldData') }}
                </th>
                <th class="w-1/3">
                    {{ $t('labels.newData') }}
                </th>
            </tr>
        </thead>
        <tbody class="bg-white dark:bg-gray-800">
            <tr
                v-for="(itemHeader, index) in headers"
                :key="index">
                <template v-if="getValue(index, itemHeader, true) || getValue(index, itemHeader, false)">
                    <td>
                        {{ itemHeader.label }}
                    </td>

                    <td>
                        <template v-if="index === 'status'">
                            <status
                                :status="getValue(index, itemHeader, true)"
                                :module="module" />
                        </template>
                        <template v-else>
                            <span>
                                {{ getValue(index, itemHeader, true) }}
                            </span>
                        </template>
                    </td>
                    <td>
                        <template v-if="index === 'status'">
                            <status
                                :status="getValue(index, itemHeader, false)"
                                :module="module" />
                        </template>
                        <template v-else>
                            <span>
                                {{ getValue(index, itemHeader, false) }}
                            </span>
                        </template>
                    </td>
                </template>
            </tr>
        </tbody>
    </table>
</template>

<script lang="ts" setup>
import Status from '@/pages/trucker-[id]/statistics/-components/status.vue'

const props = defineProps({
  itemDetailActivity: {
    type: Object,
    default: () => {},
    required: true
  },
  headers: {
    type: Object,
    default: () => {},
    required: true
  },
  module: {
    type: String,
    required: true
  }
})

const { headers, itemDetailActivity } = toRefs(props)

const { $formatters } = useNuxtApp()
const getValue = (key: string, prop: { [key: string]: any }, isOldData: boolean = false) => {
  let data = null
  if (isOldData) {
    data = itemDetailActivity.value.oldData[key]
  } else {
    data = itemDetailActivity.value.newData.$set[key]
  }

  if (typeof prop.valueFormatter === 'function') {
    return prop.valueFormatter(data)
  }
  switch (prop.type) {
  case 'string':
    return data
  case 'number':
    if ($lodash.isNil(data)) {
      return null
    }
    return $formatters.formatCurrency(data)
  default:
    return data
  }
}
</script>

<style scoped></style>
